export function mobileValidator(value) {
  /*When value not number then try to convert bangla to english number*/

  const pattern = /(^(\+88|0088)?(01){1}[3456789]{1}(\d){8})$/;
  const valid_number =
    value.match(pattern); /*Regular expression to validate number*/
  /*When valid return without +88/88 number if exist*/
  if (valid_number) {
    return valid_number[1]; /*valid number method return 3 with actual input*/
  } else {
    return false; /*return false when not valid*/
  }
}
